import regions from '@/assets/json/region.json';
import request from '@/common/request';
import { baseURL } from '@/config/base';
import moment from 'moment';
import { getLocalStorage } from './cookies';

const { NODE_ENV } = process.env;
export const isDev = NODE_ENV === 'development';

/**
 * 生成随机的uuid
 */
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
const DATE_FORMAT = 'YYYY-MM-DD';
export const getUuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-mixed-operators,no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

/**
 * 生成随机len位数字
 * @param len 长度
 * @param date
 * @returns
 */
export const randomLenNum = (len: number, date?: boolean) => {
  let random = '';
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, len || 4);
  if (date) random += Date.now();
  return random;
};

export function getBase64(img: any, callback: any) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export function getUserInfoFromIdCard(IdCard: string) {
  const birthDay = moment(IdCard.substring(6, 14), 'YYYYMMDD');
  const gender = window.parseInt(IdCard.substr(16, 1)) % 2 === 1 ? 'male' : 'female';
  const age = moment().diff(birthDay, 'year');
  return {
    birthDay: birthDay.format('YYYY-MM-DD'),
    gender,
    age,
  };
}

export function handelOptions(obj: any) {
  if (!obj) return [];
  const options = Object.keys(obj).map((key: any) => {
    return { label: obj[key].name, value: obj[key].code };
  });
  return options;
}

export function handleDicToObj(dictArr: any) {
  const newDictObj: any = {};
  Object.keys(dictArr).forEach((key) => {
    newDictObj[key] = {};
    dictArr[key].forEach((item: any) => {
      newDictObj[key][item.code] = item.name;
    });
  });
  return newDictObj;
}
// 预览文件地址
export function previewFile(fileId: string) {
  return `${baseURL}cs/file/preview/${fileId}`;
}
// 下载文件地址
export function getDownloadFileUrl(fileId: string) {
  return `${baseURL}cs/file/download/${fileId}`;
}

export function downloadFile(fileId: string, fileName?: string) {
  const url = getDownloadFileUrl(fileId);
  // @ts-ignore
  request(url, { isFile: true })
    .then((res: any) => {
      const blob = res.data;
      const link = document.createElement('a');
      link.style.display = 'none';
      const fileNameQueryParams = res.headers['content-disposition'].split(';').filter((s: string) => s.indexOf('filename') > -1)[0];
      const fileType = fileNameQueryParams ? fileNameQueryParams.split('.')[1] : null;
      link.href = window.URL.createObjectURL(new Blob([blob]));
      link.download = `${fileName || fileId}.${fileType}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
}

export function getRegionsName(regionCodes: string[]) {
  if (regionCodes) {
    let regionsData: any = regions;
    const res: any = [];
    regionCodes.forEach((code) => {
      regionsData.forEach((regionItem: any) => {
        if (code === regionItem.id) {
          res.push(regionItem.name);
          regionsData = regionItem.children;
        }
      });
    });
    return res;
  }
  return [];
}
const zeroize = (num: number) => {
  return num < 10 ? `0${num}` : num;
};
/**
 * 日期时间格式转换
 * @param
 * @returns
 */
export const timestampFormat = (dateTimeStamp: any) => {
  const dateTime = new Date(dateTimeStamp); // 将传进来的字符串或者毫秒转为标准时间
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const day = dateTime.getDate();
  const hour = dateTime.getHours();
  const minute = dateTime.getMinutes();
  // let second = dateTime.getSeconds()
  const millisecond = dateTime.getTime(); // 将当前编辑的时间转换为毫秒
  const now = new Date(); // 获取本机当前的时间
  const nowNew = now.getTime();
  let milliseconds = 0;
  let timeSpanStr: string = '';
  milliseconds = nowNew - millisecond;
  if (milliseconds <= 1000 * 60 * 1) {
    // 小于一分钟展示为刚刚
    timeSpanStr = '刚刚';
  } else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) {
    // 大于一分钟小于一小时展示为分钟
    timeSpanStr = `${Math.round(milliseconds / (1000 * 60))}分钟前`;
  } else if (1000 * 60 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24) {
    // 大于一小时小于一天展示为小时
    timeSpanStr = `${Math.round(milliseconds / (1000 * 60 * 60))}小时前`;
  } else if (1000 * 60 * 60 * 24 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24 * 15) {
    // 大于一天小于十五天展示位天
    timeSpanStr = `${Math.round(milliseconds / (1000 * 60 * 60 * 24))}天前`;
  } else if (milliseconds > 1000 * 60 * 60 * 24 * 15 && year === now.getFullYear()) {
    timeSpanStr = `${zeroize(year)}-${zeroize(month)}-${zeroize(day)} ${zeroize(hour)}:${zeroize(
      minute,
    )}`;
  } else {
    timeSpanStr = `${zeroize(year)}-${zeroize(month)}-${zeroize(day)} ${zeroize(hour)}:${zeroize(
      minute,
    )}`;
  }
  return timeSpanStr;
};

/**
 * 时间格式 YYYY-MM-DD
 * @param date moment 格式
 * @param format 格式
 * @returns string
 */
export function formatToDate(date: moment.MomentInput = undefined, format = DATE_FORMAT): string {
  return moment(date).format(format);
}
/**
 * 时间格式 YYYY-MM-DD HH:mm
 * @param date moment 格式
 * @param format 格式
 * @returns string
 */
export function formatToDateHms(
  date: moment.MomentInput = undefined,
  format = DATE_TIME_FORMAT,
): string {
  return moment(date).format(format);
}

const getStandardDateBeforeWeek = () => {
  const date = new Date();
  date.setDate(date.getDate() - 6);
  const year = date.getFullYear();
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }
  return `${year}-${month}-${day}`;
};

export function getTimeFrame(date: string) {
  const time: any = [];
  const str: any = date.replace(/\s+/g, '');
  const day: any = new Date();
  if (str === '今日') {
    time[0] = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
    time[1] = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
  } else if (str === '最近一周') {
    time[0] = getStandardDateBeforeWeek(); // 获取7天前的日期
    time[1] = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
  } else if (str === '最近一月') {
    const now = new Date();
    const year = now.getFullYear();
    const month: any = now.getMonth() + 1;
    const days = day.getDate();

    time[1] = `${year}-${month}-${days}`;
    let lsTime: string = '';
    const nowMonthDay = new Date(year, month, 0).getDate();
    if (month - 1 <= 0) {
      // 如果是1月，年数往前推一年<br>
      lsTime = `${year - 1}-${12}-${days}`;
    } else {
      const lastMonthDay = new Date(year, parseInt(month, 10) - 1, 0).getDate() + 1;
      if (lastMonthDay < days) {
        // 1个月前所在月的总天数小于现在的天日期
        if (days < nowMonthDay) {
          // 当前天日期小于当前月总天数
          lsTime = `${year}-${month - 1}-${lastMonthDay - (nowMonthDay - days)}`;
        } else {
          lsTime = `${year}-${month - 1}-${lastMonthDay}`;
        }
      } else {
        lsTime = `${year}-${month - 1}-${days}`;
      }
    }
    time[0] = `${lsTime}`;
  } else if (str === '最近半年') {
    const cc = day.getTime();
    const halfYear = (365 / 2) * 24 * 3600 * 1000;
    const pastResult = cc - halfYear;
    const pastDate = new Date(pastResult);
    time[0] = `${pastDate.getFullYear()}-${pastDate.getMonth() + 1}`;
    time[1] = `${new Date()}`;
  } else if (str === '最近一年') {
    const cc = day.getTime();
    const halfYear = 365 * 24 * 3600 * 1000;
    const pastResult = cc - halfYear;
    const pastDate = new Date(pastResult);
    time[0] = `${pastDate.getFullYear()}-${pastDate.getMonth() + 2}`;
    time[1] = `${new Date()}`;
  }
  return [formatToDate(time[0]), formatToDate(time[1])];
}

export function handleTreeData(treeData: any[], searchValue: string, parentIds: any[] = []) {
  if (!treeData || treeData.length === 0) {
    return { array: [], parentIds };
  }
  const array: any = [];
  for (let i = 0; i < treeData.length; i += 1) {
    if (
      handleTreeData(treeData[i].children, searchValue, parentIds).array.length > 0 ||
      treeData[i].name.includes(searchValue)
    ) {
      parentIds.push(treeData[i].value);
      array.push({
        ...treeData[i],
        children: handleTreeData(treeData[i].children, searchValue, parentIds).array,
      });
    }
  }
  return { array, parentIds };
}

// 展开收起，获取节点
const getNode = (children: any, initial: any) => {
  const data: any = initial;
  children?.forEach((el: any) => {
    if (el.children && el.children.length !== 0) {
      data.push(el.id);
      if (el.children) getNode(el.children, data);
    }
  });
  return data;
};

export function getNodeShow(children: any | []) {
  const nodeData: any[] = getNode(children, []);
  return nodeData;
}

export function isEmpty(a: any) {
  if (a === '') return true; // 检验空字符串
  if (a === 'null') return true; // 检验字符串类型的null
  if (a === 'undefined') return true; // 检验字符串类型的 undefined
  if (!a && a !== 0 && a !== '') return true; // 检验 undefined 和 null
  // eslint-disable-next-line no-prototype-builtins
  if (JSON.stringify(a) === '[]') return true; // 检验空数组
  if (JSON.stringify(a) === '{}') return true; // 检验空对象
  return false;
}

export function getBirth(idCard: string) {
  let birthday = '';
  if (idCard != null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = `19${idCard.slice(6, 12)}`;
    } else if (idCard.length === 18) {
      birthday = idCard.slice(6, 14);
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
    // 通过正则表达式来指定输出格式为:1990-01-01
  }
  return birthday;
}

export function getSex(idCard: string) {
  let sexStr = '';
  if (parseInt(idCard.slice(-2, -1), 10) % 2 === 1) {
    sexStr = 'male';
  } else {
    sexStr = 'female';
  }
  return sexStr;
}

export function getAgeByBirth(birthday: any) {
  if (birthday) {
    const newBirthday = birthday.substring(0, 10).split('-');
    // 新建日期对象
    const date = new Date();
    // 今天日期，数组，同 birthday
    const today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
    // 分别计算年月日差值
    const age = today.map((val, index) => {
      return val - Number(newBirthday[index]);
    });
    // 当天数为负数时，月减 1，天数加本月总天数
    if (age[2] < 0) {
      // 获取当月总天数的方法
      const curMonth = new Date(today[0], today[1], 0);
      age[1] -= 1;
      age[2] += curMonth.getDate();
    }
    // 当月数为负数时，年减 1，月数加上 12
    if (age[1] < 0) {
      age[0] -= 1;
      age[1] += 12;
    }
    return age[0];
  }
  return '';
}

/**
 * 校验身份证是否正确
 * @param idCard 身份证号
 * @returns
 */
export const validateIdCard = (idCard?: string) => {
  const idcardReg =
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return idcardReg.test(idCard || 'idCard');
};

export function filterChildren(arr: any) {
  if (arr.length && arr.length <= 0) return [];
  return arr.map((item: any) => {
    const newItem = item;
    if (item.children && item.children.length <= 0) {
      delete newItem.children;
    } else {
      newItem.children = filterChildren(item.children);
    }
    return newItem;
  });
}

// 页面按钮权限
export function isPermission(key: string) {
  let is: boolean = false;
  if (isDev) {
    is = true;
  } else {
    const permission = getLocalStorage('permission') || [];
    if (permission?.indexOf(key) !== -1) {
      is = true;
    }
  }
  return is;
}

export function searchTreeData(treeData: any[], searchValue: string): any {
  const newTreeData: any[] = [];
  for (let i = 0; i < treeData.length; i += 1) {
    if (treeData[i].name.includes(searchValue)) {
      newTreeData.push(treeData[i]);
    } else if (treeData[i].children && treeData[i].children.length > 0) {
      const children = searchTreeData(treeData[i].children, searchValue);
      if (children.length > 0) {
        newTreeData.push(treeData[i]);
      }
    }
  }
  return newTreeData;
  // return treeData.filter((item: any) => {
  //   const newItem = item;
  //   if (item.name.includes(searchValue)) {
  //     return true;
  //   }
  //   if (newItem.children && newItem.children.length > 0) {
  //     const children = searchTreeData(newItem.children, searchValue);
  //     if (children.length > 0) {
  //       return true;
  //     }
  //   }
  //   return false;
  // });
}

/**
 * 身份证脱敏
 * @param id
 * @returns
 */
export function maskIdNumber(id: string): string {
  const maskedId = id.replace(/(\w{6})\w*(\w{4})/, '$1******$2');
  return maskedId;
}

/**
 * 手机号脱敏
 *
 */
export function maskPhoneNumber(phone: string): string {
  const maskedId = phone.replace(/(\w{3})\w*(\w{4})/, '$1****$2');
  return maskedId;
}

/**
 * 姓名脱敏：两位隐藏末位，两位以上隐藏中间
 * 例：张三 → 张*；张三丰 → 张*丰；欧阳娜娜 → 欧**娜
 */
export function maskName(name: string): string {
  if (!name) return name;
  const chars = Array.from(name);
  const len = chars.length;
  if (len <= 1) return name;
  if (len === 2) return `${chars[0]}*`;
  return `${chars[0]}${'*'.repeat(len - 2)}${chars[len - 1]}`;
}

/** 按开关展示姓名：needMask 为 true 时脱敏 */
export function displayName(name?: string, needMask?: boolean): string {
  if (!name) return name || '';
  return needMask ? maskName(name) : name;
}

/** 按开关展示手机号：needMask 为 true 时脱敏 */
export function displayPhone(phone?: string, needMask?: boolean): string {
  if (!phone) return phone || '';
  return needMask ? maskPhoneNumber(phone) : phone;
}

// 获取时间场景
export const getObtainTimeScenario = (day: any) => {
  const now = moment(); // 当前时间
  const targetDateTime = moment(day);
  let ts: any = null;
  if (targetDateTime.isSame(now, 'day')) {
    ts = 0; // 今天
  } else if (targetDateTime.isBefore(now)) {
    ts = -1; // 过去
  } else {
    ts = 1; // 将来
  }
  return ts;
};

export default {
  getUuid,
  randomLenNum,
  getBase64,
};
